//Mobile Header
const mobileHeaderBtns = document.querySelectorAll(
  '[data-mobile-nav-btn]'
);
const mobileHeader = document.querySelector('#mobileHeader');
const childLinkContainers = document.querySelectorAll(
  '.mobile-navigation__child-links-container'
);

mobileHeaderBtns.forEach(btn => {
  btn.addEventListener('click', () => {
    if (mobileHeader) {
      mobileHeader.classList.toggle('open');
      document
        .querySelector('body')
        .classList.toggle('overflow-hidden');
    }
    navigationInner.classList.add('active');
    setTimeout(() => {
      childLinkContainers.forEach(el => {
        el.classList.remove('active');
      });
    }, 300);
  });
});

/* Mobile Navigation */
const navigationInner = document.querySelector(
  '.mobile-navigation-inner'
);
const mobileNavBtns = document.querySelectorAll(
  '.mobile-navigation__link-container'
);

mobileNavBtns.forEach(btn => {
  btn.addEventListener('click', e => {
    const link = e.currentTarget.dataset.link;
    const childLinks = document.querySelector(
      `.mobile-navigation__child-links-container[data-link="${link}"]`
    );
    childLinks.classList.add('active');
    navigationInner.classList.remove('active');
  });
});

/* EnterView  */
const reveals = document.querySelectorAll('.reveal');
const stagger = document.querySelectorAll('.stagger');

if (reveals.length > 0) {
  enterView({
    selector: '.reveal',
    enter: (el, i) => {
      el.classList.add('entered');
    },
    exit: el => {
      el.classList.remove('entered');
    },
    offset: 0.1
  });
}

if (stagger.length > 0) {
  stagger.forEach(el => {
    el.querySelectorAll('.stagger-child').forEach((e, i) => {
      e.style.setProperty('--animation-order', i);
    });
  });
}

// SWIPER
const swiperProduct = new Swiper('#swiper-product', {
  direction: 'horizontal',
  slidesPerView: 1,
  pagination: {
    el: '.swiper-pagination',
    clickable: true
  }
});

const swiperFeaturedBlog = new Swiper('#swiper-featured-blog', {
  direction: 'horizontal',
  slidesPerView: 1.2,
  spaceBetween: 12,
  slidesOffsetBefore: 16,
  slidesOffsetAfter: 16,
  breakpoints: {
    768: {
      slidesPerView: 4,
      spaceBetween: 24,
      slidesOffsetBefore: 0,
      slidesOffsetAfter: 0
    }
  }
});

const swiperFeaturedCollection = new Swiper(
  '#swiper-featured-collection',
  {
    direction: 'horizontal',
    slidesPerView: 1.2,
    spaceBetween: 12,
    slidesOffsetBefore: 16,
    slidesOffsetAfter: 16,
    breakpoints: {
      768: {
        slidesPerView: 4,
        spaceBetween: 24,
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0
      }
    }
  }
);

const swiperProductRecommendations = new Swiper(
  '#swiper-product-recommendations',
  {
    direction: 'horizontal',
    slidesPerView: 1.2,
    spaceBetween: 12,
    slidesOffsetBefore: 16,
    slidesOffsetAfter: 16,
    breakpoints: {
      768: {
        slidesPerView: 4,
        spaceBetween: 24,
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0
      }
    }
  }
);

const swiperFeaturedCollectionFeaturedItem = new Swiper(
  '#swiper-featured-collection--featured-item',
  {
    direction: 'horizontal',
    slidesPerView: 2,
    spaceBetween: 12,
    breakpoints: {
      768: {
        slidesPerView: 2,
        spaceBetween: 24
      }
    }
  }
);

// NAVIGATION MOBILE
const navigationMobile = document.querySelector('#navigation-mobile');
const headerWrapperMobile = document.querySelector('header.mobile');
const menuItemsMobile = Array.from(
  document.querySelectorAll('#headerMenuItemMobile')
);
const childLinksMobile = document.querySelectorAll(
  '.navigation__child-link--mobile'
);

menuItemsMobile.forEach(item => {
  item.addEventListener('click', e => {
    const navItem = item.dataset.navItem;

    menuItemsMobile.forEach(menuItem =>
      menuItem.classList.remove('active')
    );
    document
      .querySelectorAll('#navChildMenuMobile.active')
      .forEach(el => {
        el.classList.remove('active');
      });

    if (item.classList.contains('has-children')) {
      const childLink = document.querySelector(
        `#navChildMenuMobile[data-nav-item="${navItem}"]`
      );

      if (childLink) {
        childLink.classList.add('active');
        item.classList.add('active');
      }
    }
  });
});
// END OF NAVIGATION MOBILE

// NAVIGATION
const navigation = document.querySelector('#navigation');
const headerWrapper = document.querySelector('header');
const menuItems = Array.from(
  document.querySelectorAll('#headerMenuItem')
);
const childLinks = document.querySelectorAll(
  '.navigation__child-link'
);
const columnHeadings = document.querySelectorAll(
  '.navigation__column-heading'
);

menuItems.forEach(item => {
  item.addEventListener('mouseenter', e => {
    const navItem = item.dataset.navItem;

    navigation.classList.remove('active');
    headerWrapper.classList.remove('nav-active');
    menuItems.forEach(menuItem =>
      menuItem.classList.remove('active')
    );
    document.querySelectorAll('#navChildMenu.active').forEach(el => {
      el.classList.remove('active');
    });

    if (item.classList.contains('has-children')) {
      const childLink = document.querySelector(
        `#navChildMenu[data-nav-item="${navItem}"]`
      );

      if (childLink) {
        childLink.classList.add('active');
        item.classList.add('active');
        navigation.classList.add('active');
        headerWrapper.classList.add('nav-active');
      }
    }
  });
});

navigation.addEventListener('mouseleave', () => {
  navigation.classList.remove('active');
  headerWrapper.classList.remove('nav-active');
  menuItems.forEach(menuItem => menuItem.classList.remove('active'));
  childLinks.forEach(child => child.classList.remove('active'));
  document
    .querySelectorAll('.navigation__sub-links.active')
    .forEach(subList => {
      subList.classList.remove('active');
      subList.style.maxHeight = null;
    });
});

columnHeadings.forEach(heading => {
  heading.addEventListener('click', e => {
    const parent = heading.parentElement;
    const subList = parent.querySelector('.navigation__sub-links');

    if (subList) {
      e.preventDefault();

      const isOpen = subList.classList.contains('active');

      document
        .querySelectorAll('.navigation__sub-links.active')
        .forEach(list => {
          list.classList.remove('active');
          list.style.maxHeight = null;
        });

      if (!isOpen) {
        subList.classList.add('active');
        subList.style.maxHeight = subList.scrollHeight + 'px';
      }
    }
  });
});
// END OF NAVIGATION

// MOBILE VIEWPORT HEIGHT FIX
(() => {
  if (
    CSS.supports('height', '100svh') ||
    CSS.supports('height', '100dvh')
  ) {
    // Browser supports modern units, no need for JS
    return;
  }

  const vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);

  // Optional: update on resize/orientation change
  window.addEventListener('resize', () => {
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  });
})();

/* Toggle Class (Generic) */
function toggleClass(modalName, className = 'active') {
  var modalActive = document.querySelector(modalName);
  modalActive.classList.toggle(className);
}

function toggleMultipleClass(
  selector1,
  selector2,
  className = 'active'
) {
  const el1 = document.querySelector(selector1);
  const el2 = document.querySelector(selector2);

  if (el1) el1.classList.toggle(className);
  if (el2) el2.classList.toggle(className);
}

// Retailers Filter
document.addEventListener('DOMContentLoaded', function () {
  const buttons = document.querySelectorAll(
    '.retailer-filter [data-id]'
  );
  const sections = document.querySelectorAll('.retailers[data-id]');
  if (!buttons.length || !sections.length) return;

  function setActiveButton(id) {
    buttons.forEach(btn =>
      btn.classList.toggle(
        'active',
        (btn.getAttribute('data-id') || '').toLowerCase() === id
      )
    );
  }

  function setActiveSection(id) {
    sections.forEach(section => {
      const match =
        (section.getAttribute('data-id') || '').toLowerCase() === id;

      if (id === 'all') {
        // show all, but remove any "active"
        section.classList.remove('is-hidden');
        section.classList.remove('active');
      } else {
        // show only the matching one, and mark it active
        section.classList.toggle('is-hidden', !match);
        section.classList.toggle('active', match);
      }
    });
  }

  function showAll() {
    setActiveSection('all');
    setActiveButton('all');
  }

  function activateById(id) {
    const key = (id || 'all').toLowerCase();
    if (key === 'all') return showAll();

    setActiveSection(key);
    setActiveButton(key);
  }

  buttons.forEach(button => {
    button.addEventListener('click', e => {
      e.preventDefault();
      const id = button.getAttribute('data-id') || 'all';
      activateById(id);

      if (id === 'all') {
        history.replaceState(
          null,
          '',
          location.pathname + location.search
        );
      } else {
        history.replaceState(null, '', `#${id}`);
      }
    });
  });

  // Initial state
  const validIds = Array.from(buttons).map(btn =>
    (btn.getAttribute('data-id') || '').toLowerCase()
  );
  const hash = (
    window.location.hash.replace('#', '') || ''
  ).toLowerCase();

  if (hash && validIds.includes(hash) && hash !== 'all') {
    activateById(hash);
  } else {
    showAll();
  }

  // Back/forward sync
  window.addEventListener('hashchange', () => {
    const newHash = (
      window.location.hash.replace('#', '') || ''
    ).toLowerCase();
    if (!newHash || newHash === 'all') showAll();
    else if (validIds.includes(newHash)) activateById(newHash);
  });
});
// End of Retailers Filter

/* Toggle forgot password form */
const forgotPasswordButtons = document.querySelectorAll(
  '.login__forgot-password-button'
);

forgotPasswordButtons.forEach(button => {
  button.addEventListener('click', function (e) {
    e.preventDefault();
    toggleClass('.login__form');
    toggleClass('.forgot-password-form');

    console.log('here', button);
  });
});

/* Change Product Quantity */
function changeQuantity(formId, quantity) {
  var formQ = document.querySelector(formId);

  if (quantity == '+') {
    Number(formQ.value++);
  } else if (quantity == '-' && formQ.value > 1) {
    Number(formQ.value--);
  }
}

/* Open Cart */
function cartOpen() {
  document.querySelector('body').classList.add('js-my-cart-open');
}

/* Details Animator */
const details = document.querySelectorAll('details');

if (details) {
  details.forEach(targetDetail => {
    targetDetail.addEventListener('click', function (e) {
      if (targetDetail.hasAttribute('open')) {
        e.preventDefault();
        targetDetail.classList.add('closing');
        setTimeout(() => {
          targetDetail.removeAttribute('open');
          targetDetail.classList.remove('closing');
        }, 390);
      }
    });
  });
}

/* Orphan Remove and LSEP Removal */
var nbspSelectors = [
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'p',
  'a',
  'span'
];
var nbspWordMin = 10; //Minimum words within parent tag to activate script

nbspSelectors.forEach(function (selector) {
  var nbspElements = document.querySelectorAll(selector);
  nbspElements.forEach(function (element) {
    element.innerHTML = element.innerHTML.replace(/\u2028/g, '');
    element.innerHTML = element.innerHTML.replace(/&#8232;/g, '');
    var wordCount = element.innerHTML.split(' ').length;
    if (wordCount >= nbspWordMin) {
      element.innerHTML = element.innerHTML.replace(
        / ([^ ]*)$/,
        '&nbsp;$1'
      );
    }
  });
});

/* Lazy Load Initialiser */
var lazyLoadInstance = new LazyLoad({});

/* Liquid Ajax Cart */

liquidAjaxCart.subscribeToCartAjaxRequests(
  (state, subscribeToResult) => {
    if (state.requestType == 'add') {
      const form = state.info.initiator;
      let btnInner = '';

      const btn = form.querySelector('button[type="submit"]');
      if (btn) {
        btnInner = btn.innerHTML;
        btn.innerHTML = 'Adding';
      }

      subscribeToResult(state => {
        const btn = form.querySelector('button[type="submit"]');
        if (state.responseData.ok) {
          cartOpen();
        }

        if (btn) {
          setTimeout(() => {
            btn.innerHTML = btnInner;
          }, 300);
        }
      });
    }
  }
);

/* enterview */
/* Load video on enter */

const llVideos = document.querySelectorAll('video.lazy');

if (llVideos.length > 0) {
  enterView({
    selector: '.video-ll',
    enter: function (el) {
      el.load();
      el.play();
    },
    offset: 0.1
  });
}

// Facets Filters
document.addEventListener('DOMContentLoaded', function () {
  const modal = document.getElementById('FiltersModal');
  const openBtn = document.querySelector('.open-filters');
  const overlay = document.querySelector('.filters-overlay');
  const form = document.getElementById('FiltersForm');

  if (!modal) return;

  const closeBtn = modal.querySelector('.filters-close');

  function openModal() {
    modal.classList.add('active');
    document.body.classList.add('no-scroll');
  }

  function closeModal() {
    modal.classList.remove('active');
    document.body.classList.remove('no-scroll');
  }

  openBtn?.addEventListener('click', openModal);
  closeBtn?.addEventListener('click', closeModal);
  overlay?.addEventListener('click', closeModal);
  form?.addEventListener('submit', closeModal);

  const toggles = document.querySelectorAll('.js-accordion-toggle');
  if (toggles.length > 0) {
    toggles.forEach(toggle => {
      toggle.addEventListener('click', function (e) {
        e.preventDefault();
        const group = toggle.closest('.filter-group');
        const options = group?.querySelector('.filter-options');
        if (!options) return;

        options.classList.toggle('active');

        const icon = toggle.querySelector('.accordion-icon');
        if (icon) {
          icon.textContent = options.classList.contains('active')
            ? '–'
            : '+';
        }
      });
    });
  }

  function syncActiveCheckboxes() {
    document
      .querySelectorAll(
        '.filter-options label input[type="checkbox"]'
      )
      .forEach(input => {
        const label = input.closest('label');
        if (!label) return;
        label.classList.toggle('is-active', input.checked);
      });
  }

  syncActiveCheckboxes();

  document.addEventListener('change', function (e) {
    const input = e.target;
    if (input?.type === 'checkbox') {
      const label = input.closest('label');
      if (!label) return;
      label.classList.toggle('is-active', input.checked);
    }
  });
});

// End of facets filters

// Account nav
function handleAccountPageNav() {
  const pathname = window.location.pathname;
  const hash = window.location.hash;
  const links = document.querySelectorAll('.account-nav-link');

  if (!links.length) return;

  links.forEach(link => link.classList.remove('active'));

  if (pathname === '/account') {
    const sections = document.querySelectorAll('.account-section');

    sections.forEach(section => section.classList.add('hidden'));

    const currentHash = hash || '#dashboard';
    const sectionId = currentHash.replace('#', 'account-');
    const activeSection = document.getElementById(sectionId);
    if (activeSection) {
      activeSection.classList.remove('hidden');
    }

    links.forEach(link => {
      const hrefHash = link.getAttribute('href').split('#')[1];
      if (`#${hrefHash}` === currentHash) {
        link.classList.add('active');
      }
    });

    if (!hash) {
      window.history.replaceState(
        null,
        '',
        `${window.location.pathname}#dashboard`
      );
    }
  }

  if (pathname.includes('/account/addresses')) {
    const addressLink = document.getElementById('addresses-link');
    addressLink?.classList.add('active');
  }
}

document.addEventListener('DOMContentLoaded', handleAccountPageNav);
window.addEventListener('hashchange', handleAccountPageNav);

// Header homepage Scroll animation
document.addEventListener('DOMContentLoaded', function () {
  const header = document.querySelector('.header');
  const isHomepage =
    document.body.classList.contains('template--home');
  const isCollection =
    document.body.classList.contains('template--collection');

  const hasCollectionImage = isCollection && document.querySelector('.collection__image');

  if (!header || (!isHomepage && !hasCollectionImage)) return;

  // Start with transparent
  header.classList.add('transparent-header');

  const handleScroll = () => {
    if (window.scrollY > 150) {
      header.classList.add('is-scrolled');
    } else {
      header.classList.remove('is-scrolled');
    }
  };

  window.addEventListener('scroll', handleScroll);
  handleScroll();
});

// Hero banner inset
document.addEventListener('DOMContentLoaded', function () {
  const firstHeroBanner = document.querySelector(
    '.shopify-section.hero-banner'
  );
  const body = document.body;

  if (
    firstHeroBanner &&
    firstHeroBanner.querySelector('.banner--inset')
  ) {
    body.classList.add('has-inset-hero');
  }
});

// Header text colour from Hero banner settings
document.addEventListener('DOMContentLoaded', () => {
  const trigger = document.querySelector('.hero-header-trigger, .collection-header-trigger');
  if (!trigger) return;

  const theme = trigger.dataset.headerTheme;
  document.documentElement.setAttribute('data-header-theme', theme);
});
